export const MY_CREDITSAFE_SVC_ID = 937;
export const MYC_TRADE_REFERENCES_SVC_ID = 944;
export const MYC_EXPENDITURES_SVC_ID = 945;
export const MYC_PAYMENTS_SVC_ID = 946;
